import { useTranslation } from "react-i18next";
import OAuthModal from "../../../components/modals/OAuthModal";
import type { OnboardingFlow } from "../useOnboardingFlow";

/**
 * OAuth-gated room join prompt, shared by the mobile and desktop onboarding
 * layouts. Only ever visible when the invited room has an OAuth config (the
 * flow opens it from `joinRoom`), so `oauthRoomName` is always set then.
 */
export function OnboardingOAuthModal({
  flow,
}: {
  flow: OnboardingFlow;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <OAuthModal
      isVisible={flow.showOAuthModal}
      title={t("Connect your account")}
      text={t(
        "Access to this space is limited to active {{roomName}} members with an up-to-date paid subscription. Please verify your membership status to continue.",
        { roomName: flow.oauthRoomName }
      )}
      connectText={t("Login with {{roomName}} credentials", {
        roomName: flow.oauthRoomName,
      })}
      laterText={t("Later")}
      roomName={flow.roomName}
      roomLogoUrl={flow.roomLogoUrl}
      onConnect={() => {
        void flow.handleOAuthConnect();
      }}
      onLater={flow.handleOAuthLater}
    />
  );
}
